export const setSessionStorage = (name, val) => {
  sessionStorage.setItem(name, JSON.stringify(val));
}
/*获取sessionStorage*/
export const getSessionStorage = (name) => {
  if(sessionStorage.hasOwnProperty(name)) {
      return JSON.parse(sessionStorage.getItem(name));
  } else {
      return false;
  }
}
/*删除sessionStorage*/
export const deleteSessionStorage = (name = null) => {
  if(name != null) {
      sessionStorage.removeItem(name);
  } else {
      sessionStorage.clear();
  }
}